module.exports = __webpack_public_path__ + "img/top-gear-C_164x164.b481d000.png";